import * as React from 'react'
import { Form, Table, Button, FormGroup } from 'react-bootstrap'
import { useSelector } from 'react-redux'


import config from '../../../../constants/config'
import { workerHasPermission, JobMode } from '../Job'
import Locations from './Locations'

import { companyObj, CompanyT } from '../../../../types/Company'
import { copyObject } from '../../../../utils'
import NumberFormatValidate from '../../../../components/NumberFormatValidate'

import SignUpJob from './SignUpJob'
import { extractVariable, getMinimumTime } from '../JobUtils'

import { currentUserIsClient, currentUserIsManager, currentUserIsWorker, getCurrentUserId } from '../../../../utils/currentUser'
import { formatDate, formatDateToUtc, parseFloatTotal } from '../../../../utils/utilsT'
import FormPaymentJob from '../../../../components/FormPaymentJob/FormPaymentJob'
import { FormChangingCrewSize } from './FormChangingCrewSize'
import { JobT, JobTypeT } from '../../../../types/Job'
import { JobWorkerObj } from '../../../../types/JobWorker'
import { OptionsJobSource, OptionsJobStatus, OptionsJobType } from '../OptionsFieldsJob'
import { IAppState } from '../../../../redux/reducers'
import _ from 'lodash'
import GoogleMapView from '../../../../components/MapView/GoogleMapView'
import InputDatePicker from '../../../../components/InputDatePicker'
import TimePicker from 'rc-time-picker'
import { css } from 'glamor'
import moment from 'moment'

import { AxiosInstance } from '../../../../utils/RequestMethods'
import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading'


const format12Hours = 'h:mm A';

const styles = {
  inputTimePicker: css({
    border: "none !important",
    borderBottom: "1px solid #ccc !important",
    padding: ".3rem 0.55rem 0 !important",
    height: "2.1rem !important",
    fontSize: "1rem !important",
    ':disabled': {
      color: "#666 !important",
      backgroundColor: '#eeee !important',
    },
  }),
  popupClassName: css({
    ' input': {
      border: "none !important",
      borderBottom: "1px solid #ccc !important",
      padding: ".3rem 0.55rem 0 !important",
      height: "2.1rem !important",
      fontSize: "1rem !important",
    },

  }),

}
const labelStyle: React.CSSProperties = {
  fontWeight: 'bold'
}

interface JobTabProps {
  jobMode: JobMode
  coords: {
    latitude: Number
    longitude: Number
  }
  job: JobT
  markers: Array<{
    title: string
    description: string
    coordinate: {
      latitude: Number
      longitude: Number
    }
    id: Number
    job_status: string
    job_type: string
    job_sub_type: string
    job_datetime: Date
    bgImage: string
    pinImage: string
    bgColor: string
  }>
  propagateDate(activityDate: string): any
  strictJobTypes: Array<string>
  updateJob(key: string, value: any): void
  showRentTruck(): void
  tabIsActive: boolean
  useTruck?: boolean
  onChangeUseTruck(value: boolean | string): void
}

const JobTab: React.FunctionComponent<JobTabProps> = (props): JSX.Element => {
  let auth = useSelector((state: IAppState) => state.auth)
  const roles = auth && auth.userData && auth.userData.roles ? auth.userData.roles : []
  const currentUserId = getCurrentUserId()
  const [showTruckCTA, setShowTruckCTA] = React.useState(false)
  const isManager = currentUserIsManager()
  const isClient = currentUserIsClient()
  const isWorker = currentUserIsWorker()
  const [crewLength, setCrewLength] = React.useState(2);
  const [enabledChangeCrewSize, setEnabledChangeCrewSize] = React.useState(false);
  const [markers, setMarkers] = React.useState([]);
  // const [crew, setCrew] = React.useState([WorkerObj, WorkerObj]);
  const minimumTime = getMinimumTime(props.job)

  const [mapLoaded, setMapLoaded] = React.useState(false);
  const changeDatetimeFee = React.useMemo(() => extractVariable(props.job.companyInfo.variables, "changeDatetimeFee"), [props.job])
  // const workerPay = React.useMemo(() => getWorkerPay(props.job), [props.job])

  const editable = isManager
    || (isClient && (props.jobMode == "new" || (props.job.jobStatus == "inquiring" || props.job.jobStatus == "scheduled")))
    || (isWorker && workerHasPermission('sales', props.job, currentUserId))

  const [dirtyDate, setDirtyDate] = React.useState<boolean>(false)
  const [dirtyTime, setDirtyTime] = React.useState<boolean>(false)

  const [urlDispute, setUrlDispute] = React.useState(null)


  React.useEffect(() => {
    setCrewLength(props.job.crew.length)
  }, [props.job.crew]);

  // React.useEffect(() => {
  //     setCrewLength(crew.length)
  // }, [crew]);
  React.useEffect(() => {
    if (!_.isEqual(props.markers, markers)) {
      setMarkers(props.markers)
    }

  }, [props.markers]);


  const onChangeCrewSize = (value: number) => {
    value = value == undefined ? 0 : value
    const crew = props.job.crew
    const previouslength = crew.length
    let cloneCrew = copyObject(crew)
    const length = previouslength
    const rest = length - value

    if (value > previouslength) {
      for (let index = 1; index <= Math.abs(rest); index++) {
        // console.log("index", index)
        cloneCrew.push(JobWorkerObj)
      }
    } else {
      const newItems = cloneCrew.slice(Math.abs(rest))
      cloneCrew = copyObject(newItems)
      // console.log("newItems", newItems)
    }

    setTimeout(() => {
      // setCrew(cloneCrew)
      props.updateJob('crew', cloneCrew)
    }, 100);

    // console.log("cloneCrew", cloneCrew)
  }

  const onChangeCrewMembers = (floatValue) => {
    if (floatValue != crewLength) {
      if (floatValue > 100) {
        if (props.job.jobStatus == "inquiring") {
          setTimeout(() => {
            onChangeCrewSize(100)
          }, 100);
        }
        setCrewLength(100)
      } else {
        if (props.job.jobStatus == "inquiring") {
          setTimeout(() => {
            onChangeCrewSize(floatValue)
          }, 100);
        }
        setCrewLength(floatValue)
      }
    }
  }


  const renderInputJobDate = () => {
    return (
      <div className='d-flex flex-column mt-2' style={{ gap: 2 }}>
        <div className='d-flex flex-column'>
          <Form.Label style={labelStyle}>Date</Form.Label>
          <InputDatePicker
            disabled={props?.job?.jobStatus == 'completed'}

            className="input-material"
            style={{ width: '100%' }}
            selectedDate={(props?.jobMode == "new" && !dirtyDate) ? '' : props?.job?.jobDate && moment(props?.job?.jobDate).isValid() ? formatDate(props?.job?.jobDate, "YYYY-MM-DD HH:mm:ss", true) : ''}
            // selectedDate={`${props?.job?.jobDate ? props?.job?.jobDate : ""}`}
            onChangeDate={(date) => {
              let tempDate: moment.Moment = moment(date)
              if (dirtyTime) {
                tempDate.hour(moment(props?.job?.jobDate).hour())
                tempDate.minute(moment(props?.job?.jobDate).minute())
              }
              props.updateJob('jobDate', formatDateToUtc(tempDate))
              setDirtyDate(true)
              // updateActivity(props.index, { ...props.activity, activityDate: `${val}` })

            }}
            onChange={(val) => {

            }}
            dateFormat="MM/dd/yyyy"
            placeholder=""
          />
        </div>
        <div className='d-flex flex-column'>
          <Form.Label style={labelStyle}>Time</Form.Label>
          <TimePicker
            minuteStep={15}
            showSecond={false}
            disabled={props?.job?.jobStatus == 'completed'}
            value={(props?.jobMode == "new" && !dirtyTime) ? null : (props?.job?.jobDate) && moment(props?.job?.jobDate).isValid() ? moment(formatDate(props?.job?.jobDate, "YYYY-MM-DD HH:mm:ss", true)) : null}
            inputClassName={`input-material ${styles.inputTimePicker}`}
            popupClassName={` ${styles.popupClassName}`}
            onChange={(date) => {

              let tempTime: moment.Moment = moment(date)
              if (dirtyDate) {
                tempTime.date(moment(props.job.jobDate).date())
                tempTime.month(moment(props.job.jobDate).month())
                tempTime.year(moment(props.job.jobDate).year())
              }
              props.updateJob('jobDate', formatDateToUtc(tempTime))
              setDirtyTime(true)
            }}
            format={config.dateFormat.time12Hours}
            use12Hours
            inputReadOnly
          />
        </div>
      </div>
    )
  }

  const renderContent = () => {
    console.log('PROPS.JOBXXX');
    console.log(props.job)
    return (
      <>
        {(isClient || isManager) && renderInputJobDate()}
        {(isWorker && props.job.jobStatus == 'scheduled') && <SignUpJob job={props.job} />}

        {isClient && <>
          <Form.Label style={labelStyle}>Number of Crew Members</Form.Label>
          <NumberFormatValidate
            disabled={!editable && !enabledChangeCrewSize}
            customInput={Form.Control}
            className="input-material"
            type="text"
            // defaultValue={`${job.crew.length}`}
            value={`${crewLength}`}
            onValueChange={(values) => {
              const { formattedValue, value, floatValue } = values
              onChangeCrewMembers(floatValue)

            }}
            max={100}
            mask="_" />

          {crewLength != props.job.crew.length && (crewLength <= 0 || !crewLength) && <Form.Text style={{ color: "#cc0000" }}>
            Crew size must be at least 1.
          </Form.Text>}

          {(isClient && props.job.jobStatus == "scheduled" && crewLength != props.job.crew.length && crewLength > 0) &&
            <FormChangingCrewSize job={props.job} crewSize={crewLength}
              show={() => {
                setEnabledChangeCrewSize(true)

              }}
              hide={() => {
                setCrewLength(props.job.crew.length)
                setEnabledChangeCrewSize(false)
              }}
            />
          }


          {props.jobMode == "new" && <>
            <FormGroup>
              <Form.Label style={labelStyle}>Need moving truck?</Form.Label>
              <Form.Control
                required
                as="select"
                className='input-material'
                // isValid={isEmail(client.email)}
                value={`${props.useTruck == true ? 1 : 0}`}
                onChange={(e) => {
                  let value = e.target.value
                  console.log("value", value)
                  props.onChangeUseTruck(value)

                }}>
                <option></option>
                <option value="1">Yes</option>
                <option value="0">No</option>
              </Form.Control>
            </FormGroup>
          </>}

          <Form.Label style={labelStyle}>Notes</Form.Label>
          <Form.Control
            as='textarea'
            value={`${props.job.notes}`}
            className='input-material'
            onChange={(event: any): void => { props.updateJob('notes', event.target.value) }}
            rows={2} />
        </>}

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>
          {isManager && <span>
            <Form.Label style={labelStyle}>Job Type</Form.Label>
            <Form.Control
              as='select'
              className='input-material'
              value={`${props.job.jobType}`}
              onChange={(event: any) => { props.updateJob('jobType', event.target.value) }}>
              {Object.keys(OptionsJobType).map((key, index) => {
                return (
                  <option key={index} disabled={props.strictJobTypes.includes(key) ? false : true} value={key} >{OptionsJobType[key]}</option>
                )
              })}

            </Form.Control>
          </span>}
          {(isManager || (isWorker && workerHasPermission('sales', props.job, currentUserId))) && <span>
            <Form.Label style={labelStyle}>Job Status</Form.Label>
            <Form.Control
              as='select'
              className='input-material'
              value={`${props.job.jobStatus}`}
              onChange={(event: any) => { props.updateJob('jobStatus', event.target.value) }}>
              {Object.keys(OptionsJobStatus).map((key, index) => {
                return (
                  <option key={index} value={key} >{OptionsJobStatus[key]}</option>
                )
              })}
            </Form.Control>
          </span>}
          {isManager && <span>
            <Form.Label style={labelStyle}>Job Source</Form.Label>
            <Form.Control
              as='select'
              className='input-material'
              value={`${props.job.jobSource}`}
              onChange={(event: any) => { props.updateJob('jobSource', event.target.value) }}>
              {Object.keys(OptionsJobSource).map((key, index) => {
                return (
                  <option key={index} value={key} >{OptionsJobSource[key]}</option>
                )
              })}

            </Form.Control>
          </span>}
        </div>
        {(isManager && props.job.jobType != JobTypeT.intrastate_long && props.job.jobType != JobTypeT.interstate && props.job.jobType != JobTypeT.international) &&
          <span>
            <Form.Label style={labelStyle}>Minimum Hours</Form.Label>
            <NumberFormatValidate
              customInput={Form.Control}
              className="input-material"
              type="text"
              defaultValue={(props.job.companyInfo.variables && props.job.companyInfo.variables.minimumTime && props.job.companyInfo.variables.minimumTime.value) ? `${props.job.companyInfo.variables.minimumTime.value}` : ''}
              value={(props.job.companyInfo.variables && props.job.companyInfo.variables.minimumTime && props.job.companyInfo.variables.minimumTime.value) ? `${props.job.companyInfo.variables.minimumTime.value}` : ''}
              onValueChange={(values) => {
                const { formattedValue, value, floatValue } = values;
                let companyInfo = { ...companyObj, ...props.job.companyInfo }
                companyInfo.variables.minimumTime.value = floatValue
                props.updateJob('companyInfo', companyInfo)
              }}
              mask="_"
            />

          </span>}
        {isManager && false && <>
          <Form.Label style={labelStyle}>Vehicles</Form.Label>
          <Form.Control
            className='input-material'
            onChange={(event: any): void => { props.updateJob('notes', event.target.value) }} />
          {showTruckCTA /* TODO: Add truck_schedule_safety_margin to Settings */ && <div>
            <Table>
              {/*/ Show available trucks if truck-jpb scheduling conflict exists with
            1) closest time before if it's booked, calculated by estimated job duration, and 2) closest time after */}
              <tr>
                <td>Projected Price w/o Gas</td>
                <td>Projected Gas Cost</td>
                <td>Vendor</td>
                <td>
                  <Button variant='outline-success'>Rent</Button>
                </td>
              </tr>
            </Table>
          </div>}
          <Button
            onClick={() => {
              props.showRentTruck()
              setShowTruckCTA(!showTruckCTA)

            }}
            variant='outline-secondary'>Rent Truck</Button>
          <br />
        </>}
        {isManager && <>
          <Form.Label style={labelStyle}>Notes</Form.Label>
          <Form.Control
            as='textarea'
            className='input-material'
            value={`${props.job.notes}`}
            onChange={(event: any): void => { props.updateJob('notes', event.target.value) }}
            rows={2} />
        </>}


        {isManager && props.job.fkDispute == '' && <>
          <div className='d-flex flex-column'>
            <div>
              <ButtonLoading
                variant='dark'
                timeShowMsg={100}
                onClickFetching={async (event): Promise<string> => {
                  return await AxiosInstance.post(`${config.url.jobs}/${props.job.id}/dispute/create`).then((res) => {
                    console.log('RESRESDATADATA')
                    console.log(res.data)
                    props.updateJob('fkDispute', res.data.id)
                    return 'Dispute generated.'
                  })
                }
                }>Generate Dispute Docs</ButtonLoading>
            </div>
          </div>
        </>}

        {/*isManager && <div className='d-flex flex-column'>
        <div>
          <ButtonLoading
            // noShowResultMessage
            variant='light'
            // noShowResultMessageSuccess
            // noShowResultMessageError
            timeShowMsg={100}
            onClickFetching={async (event): Promise<string> => {
              if (urlDispute) {
                navigator.clipboard.writeText(urlDispute);
                return "Dispute link copied."
              }
              return await AxiosInstance.post(`${config.url.jobs}/${props.job.id}/communications/dispute/create_token`).then((res) => {
                if (res?.data) {
                  let url = `${window.location.host}/job/${props?.job?.id}/dispute/${res?.data?.token}`
                  setUrlDispute(url)
                  navigator.clipboard.writeText(url);
                  return "Dispute link generated."
                }
              })

            }}>{urlDispute ? "Copy dispute link " : "Generate dispute link"}</ButtonLoading>
        </div>
          </div>*/}


        {(isManager || isWorker || isClient || props.jobMode == JobMode.Dispute)
          && <Locations
            jobMode={props.jobMode}
            job={props.job}
            propagateDate={props.propagateDate}
            updateJob={props.updateJob}
            showDetails={isManager} />
        }

      </>
    )
  }

  return (
    <div className='w-100'>
      <GoogleMapView
        // mapboxApiAccessToken={config.keyMapBox}
        rotateEnabled={false}
        scrollZoom={false}
        showZoom={false}
        coordinate={{
          latitude: Number(props?.coords.latitude),
          longitude: Number(props?.coords.longitude)
        }}
        markers={markers}
        onApiLoaded={() => {
          setMapLoaded(true)
        }}
      />

      {props.tabIsActive && renderContent()}
    </div>
  )
}

export default JobTab
